import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Illustration.st.css';
import { dataHooks } from '../../constants';
import { useBaseModalLayoutContext } from '../../BaseModalLayoutContext';
import { IllustrationProps } from './Illustration.types';

export const Illustration = ({
  dataHook,
  className,
  children,
}: IllustrationProps = {}) => {
  const { illustrationClassName, illustration = children } =
    useBaseModalLayoutContext();

  return (
    (illustration && (
      <div
        data-hook={dataHook}
        className={st(classes.root, illustrationClassName, className)}
      >
        {typeof illustration === 'string' ? (
          <img
            className={classes.image}
            src={illustration}
            data-hook={dataHooks.illustrationSrc}
          />
        ) : (
          illustration
        )}
      </div>
    )) ||
    null
  );
};

Illustration.propTypes = {
  /** Specifies a CSS class name to be appended to the component’s root element.
   * @internal
   */
  className: PropTypes.string,

  /** data hook for testing */
  dataHook: PropTypes.string,

  /** The illustration src or the illustration node itself */
  illustration: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};
